import tabs from './tabs';
import modal from './modal';
import { preferences, renderPreferences } from './preferences';

require('focus-visible');

(function () {
  var pageLoadFunctions = {
    init: function () {
      if (typeof topics != 'undefined') {
        tabs();
        modal();
        renderPreferences();
        preferences();
      }
    }
  };
  document.onreadystatechange = function () {
    if (document.readyState === 'complete') {
      pageLoadFunctions.init();
    }
  };
})();

